<div class="flex flex-col justify-between space-x-2 overflow-hidden grow lg:flex-row bg-white/10 rounded-10">
  <!-- The side menu of the file library view shown on the left side -->
  <div class="w-full lg:w-64 shrink-0 flex flex-col border-r-1.5 border-solid border-white/10">
    <div class="w-full p-5 border-b-1.5 border-solid border-white/10">
      <nrc-search
        [placeholder]="'Name, type, ...'"
        [isCollapsible]="false"
        (searchEvent)="handleSearch($event)"
      />
    </div>

    <div class="w-full px-2 py-4 grow bg-black/30">
      <nrc-file-explorer
        class="w-full"
        [headline]="'All files'"
        [fileExplorer]="{
          folders: []
        }"
      />
    </div>
  </div>

  <!-- The file library list shown on the right side -->
  <div #fileLibraryModalSearchListContainer class="h-full grow">
    <nrc-list
      class="flex flex-col items-center justify-center h-full pr-2 overflow-auto"
      [ngClass]="{
        'justify-start':  (fileListItemsSig() | isNonEmptyArray),
        'justify-center': (fileListItemsSig() | isEmptyArray)
      }"
      [layout]="'grid'"
      [items]="fileListItemsSig"
      [isLoading]="isFileListLoading"
      [meta]="metaSig()?.pagination"
      [config]="{
        columns: columnsSig()
      }"
      [emptyListConfig]="{
        headline: 'Upload new file',
        content: 'There is nothing here. Upload a new file now by clicking on the button below.',
        actionLabel: 'Upload File'
      }"
      [listPaginatorOverflowParentElement]="fileLibraryModalSearchListContainer"
      (listOptionsEvent)="handleListOptions($event)"
      (emptyListActionEvent)="actionButtonEvent.emit()"
      (listItemClickedEvent)="fileSelectedEvent.emit($event)"
    />
  </div>
</div>
